import { Link } from 'react-router-dom';
import styled from 'styled-components';

import type { TotadminPermission } from 'data/__generated__';
import { useMissingPermissionsReason, usePermissionGate } from 'hooks/useHasPermission';

/**
 * Page connue, utilisateur connecté, mais aucun de ses groupes n'ouvre ce droit. Ni redirection vers
 * `/login` (il EST connecté), ni page blanche : on dit ce qui manque.
 */
export function AccessDenied({
    pageLabel,
    requiredPermissions,
}: {
    pageLabel: string;
    requiredPermissions: readonly TotadminPermission[];
}) {
    const { missing } = usePermissionGate(requiredPermissions);
    const reason = useMissingPermissionsReason(missing);

    return (
        <Container data-test="access-denied">
            <Title>Accès refusé</Title>
            <Message>
                Vos groupes de permissions ne donnent pas accès à « {pageLabel} ». Demandez à un gestionnaire des droits
                de vous ajouter au groupe adéquat.
            </Message>
            {reason ? <Missing>{reason}</Missing> : null}
            <HomeLink to="/">Retour à l&apos;accueil</HomeLink>
        </Container>
    );
}

const Container = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;
    padding: 30px;
    background-color: ${({ theme }) => theme.backgroundColor};
`;

const Title = styled.span`
    font-size: 42px;
    font-weight: 800;
    color: ${({ theme }) => theme.textColor};
`;

const Message = styled.span`
    margin-top: 12px;
    max-width: 480px;
    text-align: center;
    font-size: 16px;
    color: ${({ theme }) => theme.infoTextColor};
`;

const Missing = styled.span`
    margin-top: 8px;
    font-size: 14px;
    color: ${({ theme }) => theme.textColor};
`;

const HomeLink = styled(Link)`
    margin-top: 24px;
    font-size: 16px;
    color: ${({ theme }) => theme.textColor};
    text-decoration: underline;
`;
